import {
	Column,
	Entity,
	Index,
	JoinColumn,
	ManyToOne,
	OneToMany,
} from 'typeorm';
import { BaseEntity } from './base.entity';
import { ConversationAnalysisCriterionResultEntity } from './conversation-analysis-criterion-result.entity';
import { ConversationAnalyzerEntity } from './conversation-analyzer.entity';
import { ConversationSessionEntity } from './conversation-session.entity';

@Entity('_conversation_analysis_result')
@Index(['sessionId', 'analyzerId'])
@Index(['analyzerId', 'createdDate'])
export class ConversationAnalysisResultEntity extends BaseEntity {
	@Column({
		name: 'fk__conversation_session__id',
		type: 'int',
		unsigned: true,
	})
	public sessionId!: number;

	@ManyToOne(() => ConversationSessionEntity, {
		onDelete: 'CASCADE',
		onUpdate: 'CASCADE',
	})
	@JoinColumn({ name: 'fk__conversation_session__id' })
	public session!: ConversationSessionEntity;

	@Column({
		name: 'fk__conversation_analyzer__id',
		type: 'int',
		unsigned: true,
	})
	public analyzerId!: number;

	@ManyToOne(() => ConversationAnalyzerEntity, {
		onDelete: 'CASCADE',
		onUpdate: 'CASCADE',
	})
	@JoinColumn({ name: 'fk__conversation_analyzer__id' })
	public analyzer!: ConversationAnalyzerEntity;

	@Column({
		name: 'total_score',
		type: 'decimal',
		precision: 6,
		scale: 2,
		nullable: true,
	})
	public totalScore?: number;

	@Column({
		name: 'max_possible_score',
		type: 'decimal',
		precision: 6,
		scale: 2,
		nullable: true,
	})
	public maxPossibleScore?: number;

	@Column({
		name: 'percentage_score',
		type: 'decimal',
		precision: 5,
		scale: 2,
		nullable: true,
	})
	public percentageScore?: number;

	@Column({ name: 'passed', type: 'tinyint', width: 1, nullable: true })
	public passed?: boolean;

	@Column({
		name: 'detected_outcome',
		type: 'varchar',
		length: 50,
		nullable: true,
	})
	public detectedOutcome?: string;

	@Column({ name: 'ivr_detected', type: 'tinyint', width: 1, default: 0 })
	public ivrDetected!: boolean;

	@Column({
		name: 'ivr_navigation_success',
		type: 'tinyint',
		width: 1,
		nullable: true,
	})
	public ivrNavigationSuccess?: boolean;

	@Column({
		name: 'sentiment_score',
		type: 'decimal',
		precision: 4,
		scale: 2,
		nullable: true,
	})
	public sentimentScore?: number;

	@Column({
		name: 'end_sentiment_score',
		type: 'decimal',
		precision: 4,
		scale: 2,
		nullable: true,
	})
	public endSentimentScore?: number;

	@Column({
		name: 'analysis_summary',
		type: 'text',
		nullable: true,
		charset: 'utf8mb4',
		collation: 'utf8mb4_0900_ai_ci',
	})
	public analysisSummary?: string;

	@Column({ name: 'llm_provider', type: 'varchar', length: 50, nullable: true })
	public llmProvider?: string;

	@Column({ name: 'llm_model', type: 'varchar', length: 100, nullable: true })
	public llmModel?: string;

	@Column({ name: 'llm_execution_time_ms', type: 'int', nullable: true })
	public llmExecutionTimeMs?: number;

	@Column({ name: 'llm_tokens', type: 'int', nullable: true })
	public llmTokens?: number;

	@Column({ name: 'raw_llm_response', type: 'json', nullable: true })
	public rawLlmResponse?: unknown;

	@OneToMany(
		() => ConversationAnalysisCriterionResultEntity,
		(r) => r.analysisResult,
	)
	public criterionResults?: Array<ConversationAnalysisCriterionResultEntity>;
}
